import * as THREE from "three";
import { FikoThreeJsComponent } from "../fiko-three-js.component";
import { FikoSahne } from "./FikoSahne";
import { FikoVektor3D } from "./FikoVektor3d";

export class FikoArrowYardimci extends THREE.ArrowHelper {
    override type: any = "FikoArrowYardimci";


    constructor(public sahne?: FikoSahne, public yon?: FikoVektor3D,
        merkez?: FikoVektor3D,
        uzunluk?: number,
        renk?: THREE.Color | string | number,
        okUzunluk?: number,
        okGenislik?: number,) {
        super(yon, merkez, uzunluk, renk, okUzunluk, okGenislik);

        // 🔥 FIX: Yüksek render order - her zaman en üstte
        const EKSEN_RENDER_ORDER = 999999;
        this.renderOrder = EKSEN_RENDER_ORDER;
        this.frustumCulled = false;

        //@ts-ignore - Line ayarları
        this.line.frustumCulled = false;
        //@ts-ignore
        this.line.renderOrder = EKSEN_RENDER_ORDER;
        //@ts-ignore
        this.line.material.depthTest = false;
        //@ts-ignore
        this.line.material.depthWrite = false;
        //@ts-ignore
        this.line.material.transparent = true;

        //@ts-ignore - Cone ayarları
        this.cone.frustumCulled = false;
        //@ts-ignore
        this.cone.renderOrder = EKSEN_RENDER_ORDER;
        //@ts-ignore
        this.cone.material.depthTest = false;
        //@ts-ignore
        this.cone.material.depthWrite = false;
        //@ts-ignore
        this.cone.material.transparent = true;

        // //@ts-ignore
        // this.cone.onBeforeRender = function (renderer) { renderer.clearDepth(); }
        // this.line.onBeforeRender = function (renderer) { renderer.clearDepth(); }

        // this.onBeforeRender=function (renderer) { renderer.clearDepth(); }

        // this.cone.material = FikoThreeJsComponent.standartMaterialMesh;
        // this.cone.geometry.groups = []
        // let rgbRenk = new THREE.Color(renk);
        // let listRgb = []
        // for (let index = 0; index < this.cone.geometry.attributes.position.count; index++) {
        //     listRgb.push(rgbRenk.r, rgbRenk.g, rgbRenk.b);
        // }
        // this.cone.geometry.setAttribute("colors", new THREE.Float32BufferAttribute(listRgb, 3))
        // this.cone.geometry.attributes.colors.needsUpdate = true;

        // this.line.material = FikoThreeJsComponent.standartMaterialCizgiEdge;
        // let listRgbLine = []
        // for (let index = 0; index < this.line.geometry.attributes.position.count; index++) {
        //     listRgbLine.push(rgbRenk.r, rgbRenk.g, rgbRenk.b);
        // }
        // this.line.geometry.setAttribute("colors", new THREE.Float32BufferAttribute(listRgbLine, 3))
        // this.line.geometry.attributes.colors.needsUpdate = true;
    }

    override raycast(raycaster: THREE.Raycaster, intersects: THREE.Intersection[]): void {
        let kesisenler = raycaster.intersectObjects(this.children, true);

        if (kesisenler.length > 0) {
            intersects.push({
                object: this,
                distance: kesisenler[0].distance,
                point: kesisenler[0].point,
                face: null,
                faceIndex: null,
                index: null,
                instanceId: this.id,
                //@ts-ignore
                yon: this.yon,
                altObje: kesisenler[0].object,
            });

        } else {
            return;
        }
    }

    override toJSON(meta?: { geometries: any; materials: any; textures: any; images: any }): any {
        return super.toJSON(meta as any);
    }

    static fromJson(sahne?: FikoSahne, parent?: any, json?: any) {
        delete json.children;
        const mtrx = json.matrix;
        delete json.matrix;


        const merkez = new FikoVektor3D(json.userData.merkez.x, json.userData.merkez.y, json.userData.merkez.z);
        const uzunluk = json.uzunluk;
        const renk = json.renk;

        const _rslt = new FikoArrowYardimci(sahne, json.name, merkez, uzunluk, renk);

        _rslt.matrix.fromArray(mtrx);
        _rslt.layers = new THREE.Layers();
        _rslt.layers.set(json.layers);

        _rslt.parent = parent;

        // (sahne as SahneFikoAptSimilasyon).cizimler.eksenler.add(_rslt);
        // for (let i = 0; i < _rslt.children.length; i++) {
        //     let element = _rslt.children[i];
        //     element = mdl.jsondan(element);
        // }
        return _rslt;

    }
}